import Vue from "vue";
import * as dayjs from "dayjs";

Vue.filter('NumberFormat', function (value) {
  if (!value) {
    return '0'
  }
  let intPartFormat = value.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') //将整数部分逢三一断
  return intPartFormat
})

Vue.filter('dayjs', function(dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
  return dayjs(dataStr).format(pattern)
})

Vue.filter('moment', function(dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
  return dayjs(dataStr).format(pattern)
})

Vue.filter('OrderStatusFilter', function (value) {
  if (value > 7 || value < 0) {
    return '未知状态'
  }
  // 0:待处理 1:待发货 2:已发货 3:已完成 4: 已拒绝 5:未拼成 6:待拼成
  const status = ['待处理', '待发货', '已发货', '已完成', '已拒绝','已退款', '未拼成', '待拼成',]
  return status[value]
})

Vue.filter('OrderExchangeFilter', function (value) {
  if (value > 2 || value < 0) {
    return '未知状态'
  }
  const exchange_type = ['门店自取', '线上直邮', '线上拼兑']
  return exchange_type[value]
})

//地址筛选
Vue.filter('AreaFilter', function (areas) {
  if (!areas) {
    return ''
  }
  let names = []
  for (let area of areas) {
    names.push(area.name)
  }
  return names.join(', ')
})
//价格筛选
Vue.filter('PriceFilter', function(price, or_price) {
  if (price){
    return price
  }else{
    return or_price
  }
})
//状态筛选
Vue.filter('SorderStateFilter', function (value) {
  if (value > 6 || value < 0) {
    return '未知状态'
  }
  const status = ['待处理', '在途', '到店上架中', '到货正常', '到货异常','处理完毕','处理完毕']
  return status[value]
})
// 角色对应的意义
Vue.filter('roleNameFFilter', function (value) {
  const ROLE_MAP =  {
    clerk:'店员',
    manager:'店长',
    merchandiser:'采购',
    operations:'运营',
    admin:'管理员',
  }
  return ROLE_MAP[value]
})
//状态筛选
// Vue.filter('PurchaseStateFilter', function (value) {
//   if (value > 3 || value < 0) {
//     return '未知状态'
//   }
//   const status = ['在途', '兑换完毕', '换货', '退款']
//   return status[value]
// })
// 变动类型
Vue.filter('typeMapFilter', function (value) {
  if (value > 17 || value < 0) {
    return '未知类型'
  }
  const types = ['兑换', '零售', '采购', '调出', '调入','调出取消','库存损坏','商品被盗','员工福利','免费赠送','其他入库','其他出库','超量上架','兑换退款','零售退款',"盘点增加","盘点减少"]
  return types[value]
})


Vue.filter('allocationFilter',function(value){
  if (value > 5 || value < 0) {
    return '未知类型'
  }
  const types = ['待发货', '在途', '已入库', '处理中', '处理中','已入库']
  return types[value]
})

Vue.filter('transLogDetailFilter',function(record){
  const {type,quantity,goods_name} = record;
  if(type>11 || type <0){
    return '未知操作'
  }
  const types = ['发货', '到货正常', '到货异常', '收货', '换货','退款','处理完毕',"门店到货","超量上架","超量拒绝上架","修改钉钉单号","订单调拨"];
  let text = `${types[type]}`
  if(type===3){
    text =  `${types[type]},商品:${goods_name},数量:${quantity}`
  }
  if(type===8){
    text = `${types[type]},商品:${goods_name},数量:${quantity}`
  }
  return text;
})

Vue.filter('purchaseTypeStr',function(typeNum){
  const types = ['采购','调拨','订单调拨']
  return types[typeNum]
})
